function t(e) {
  return Object.keys(e);
}
export {
  t as keysOf
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/keysOf.js
// module id = 264
// module chunks = 67